import "core-js/modules/es.reflect.construct.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import batchPeteEvents from "@faire/web-api--source/api/client-events/post";
import { IRecordClientEventsRequest } from "@faire/web-api--source/indigofair/data/IRecordClientEventsRequest";
import { BatchEventsQueue } from "./BatchEventsQueue";
export var PeteEventsQueue = /*#__PURE__*/function (_BatchEventsQueue) {
  function PeteEventsQueue() {
    var _this;
    var retry_timeout_multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
    _classCallCheck(this, PeteEventsQueue);
    _this = _callSuper(this, PeteEventsQueue, [retry_timeout_multiplier]);
    _this.batchEvents = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(events) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return batchPeteEvents(IRecordClientEventsRequest.build({
                events: events,
                is_validation: false
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return _this;
  }
  _inherits(PeteEventsQueue, _BatchEventsQueue);
  return _createClass(PeteEventsQueue);
}(BatchEventsQueue);